/**
 * County names, without a round trip.
 *
 * The dashboard needs to name the county in the URL before any request has
 * come back, and the generated map already carries every Florida county's FIPS
 * and name. This reads that table rather than adding a second copy — the
 * backend registry is the authority on *coverage*, not on what a county is
 * called, and a test asserts the two agree on both.
 */

import { FLORIDA_COUNTY_SHAPES } from "./floridaShapes";

const NAMES: Record<string, string> = Object.fromEntries(
  FLORIDA_COUNTY_SHAPES.map((shape) => [shape.fips, shape.name]),
);

/** The county's name, or "" for a code Florida does not have. */
export function countyName(fips: string): string {
  return NAMES[fips] ?? "";
}
